module.exports = __webpack_public_path__ + "9b470ec460f69ade939c5db2656d3184.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/diver-helmet.png
// module id = 2175
// module chunks = 0